<div class="twc-container twc-m-2">
    <div class="twc-mt-1 twc-mb-3" *ngIf="subtitle">{{subtitle | translate}}</div>

    <div class="twc-row twc-col-12 twc-mb-2">
        <h3 class="twc-h3">{{'UPLOAD.OBJ_MODEL3D_CONVERTER_OPTIONS' | translate}}</h3>
    </div>

    <div>
        <div class="twc-mb-3 twc-col-3 twc-col-sm-6">
            <span class="twc-form-label">
                <strong>{{'UPLOAD.OBJ_MODEL3D_CONVETER_SELECT_SCALE_FACTOR' | translate}}</strong>
            </span>
            <twc-select [(ngModel)]="modelConversion3d.ScaleFactor">
                <twc-select-option *ngFor="let option of scaleFactorOptions" [value]="option.fromMeters">
                    {{ option.label | translate}}
                </twc-select-option>
            </twc-select>
        </div>
    </div>
</div>